import e from "react";
import t from "../../../../../../node_modules/classnames/index.js";
import { Icon as a } from "../../../../general/Icon/Icon.js";
function r(r) {
  var m = r.name,
    o = r.path,
    l = r.type,
    i = r.action,
    n = r.target,
    s = r.onClick,
    c = r.active;
  return "folder" === l ? e.createElement("div", {
    className: "profile-items-inner__title"
  }, r.name) : e.createElement("div", {
    className: "profile-items-row"
  }, e.createElement("a", {
    "data-method": i,
    href: o,
    target: n,
    onClick: s,
    className: t({
      active: c
    })
  }, e.createElement("span", {
    className: "profile-items-row__link"
  }, m), c && e.createElement(a, {
    className: "profile-items-row__active",
    name: "check",
    regular: !0
  })));
}
r.defaultProps = {
  target: "_self"
};
export { r as ProfileItemsRow };